var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"safety-monitoring"},[_c('div',{staticClass:"monitoring"},[_c('div',{staticStyle:{"height":"8.65rem"}},[_c('div',{staticClass:"video-cs"},[(this.$route.query.type == 'gc')?_c('img',{attrs:{"src":require("@/assets/images/guancun.jpg"),"alt":""}}):_c('img',{attrs:{"src":require("@/assets/images/dszx.jpg"),"alt":""}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }